export default __webpack_public_path__ + "static/media/ob-04.e0fa2f4c.svg";